( function () {
   
    'use strict';

    ( function ( $ ) {
       
      setTimeout(function(){
        $('.video-bg-content-play-icon-box').addClass('open');
        
      },2000); 
      // if($('.video-bg-content-play-slider').length > 0){
     
             
      // }

    const zeroPad = (num, places) => String(num).padStart(places, '0');
      if($('.video-bg-content-play-icon-slider').length > 0){
          var total = document.getElementById("vidx").duration;
  
            var minutes = Math.floor(total / 60); // Seconds divided by 60 to get total minutes
            var seconds = total % 60;
            var fsec= seconds.toFixed(0);
            var timer = (zeroPad(minutes, 2))+':'+(zeroPad(fsec, 2));
            //console.log('loaded, duration is now',minutes,seconds.toFixed(0));
            
            $('#timerx').html(timer);
  
      } 
        $('.popup-video-content-banner').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
              open: function() {
                $("body").addClass("overflow");
                $(this.content).find('video')[0].play();
             },
              close: function() {
                $("body").removeClass("overflow");
                jQuery(this.content).find('video')[0].pause();
              }
            }
        });
       
    } )(jQuery);
} )();

